import { useState } from "react";
import { Lock, CheckCircle, KeyRound } from "lucide-react";
import api from "@/utils/api";

export default function ChangePasswordSection() {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    if (form.next.length < 8) {
      setError("Neues Passwort muss mindestens 8 Zeichen lang sein.");
      return;
    }
    if (form.next !== form.confirm) {
      setError("Die beiden neuen Passwörter stimmen nicht überein.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current,
        new_password: form.next,
      });
      setSuccess(true);
      setForm({ current: "", next: "", confirm: "" });
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || "Passwort konnte nicht geändert werden.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
      <h2 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2">
        <KeyRound size={20} className="text-[#0D9488]" />
        Passwort ändern
      </h2>
      <p className="text-sm text-gray-500 mb-4">
        Wähle ein sicheres Passwort mit mindestens 8 Zeichen.
      </p>

      <div className="space-y-3">
        <label className="block">
          <span className="text-sm font-medium text-gray-700">Aktuelles Passwort</span>
          <input
            type="password"
            value={form.current}
            onChange={(e) => setForm({ ...form, current: e.target.value })}
            required
            autoComplete="current-password"
            data-testid="current-password-input"
            className="mt-1 w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#14B8A6]"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-gray-700">Neues Passwort</span>
          <input
            type="password"
            value={form.next}
            onChange={(e) => setForm({ ...form, next: e.target.value })}
            required
            minLength={8}
            autoComplete="new-password"
            data-testid="new-password-input"
            className="mt-1 w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#14B8A6]"
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-gray-700">Neues Passwort wiederholen</span>
          <input
            type="password"
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            required
            minLength={8}
            autoComplete="new-password"
            data-testid="confirm-password-input"
            className="mt-1 w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#14B8A6]"
          />
        </label>
      </div>

      {error && (
        <div data-testid="change-pw-error" className="mt-3 bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2 rounded-lg">
          {error}
        </div>
      )}
      {success && (
        <div data-testid="change-pw-success" className="mt-3 bg-green-50 border border-green-200 text-green-700 text-sm px-3 py-2 rounded-lg flex items-center gap-2">
          <CheckCircle size={16} />
          Passwort erfolgreich geändert.
        </div>
      )}

      <button
        type="submit"
        disabled={saving}
        data-testid="change-password-btn"
        className="mt-4 w-full py-3 bg-[#14B8A6] text-gray-900 font-semibold rounded-xl hover:bg-[#0D9488] transition-all flex items-center justify-center gap-2 disabled:opacity-50"
      >
        <Lock size={16} />
        {saving ? "Wird geändert…" : "Passwort ändern"}
      </button>
    </form>
  );
}
